<d-style-wrapper>
  <router-outlet />
</d-style-wrapper>
